/**
 * The sections whose heading or text contains every word of the search, ignoring case and accents, so "pokemon"
 * finds "Pokémon". An empty search keeps them all.
 *
 * @param {Array<{heading: string, html: string}>} sections
 * @param {string} search
 */
export function matchingSections(sections, search) {
  const words = fold(search).split(/\s+/).filter(Boolean);

  if (!words.length) {
    return sections;
  }

  return sections.filter(section => {
    const text = fold(`${section.heading} ${section.html.replace(/<[^>]+>/g, ' ')}`);
    return words.every(word => text.includes(word));
  });
}

/** Lowercase, without accents, so "pokemon" matches "Pokémon". */
export function fold(text) {
  return text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}
